import { useNavigate } from 'react-router-dom';
import RadioButton from '../../components/radioButton/radioButton';
import styles from './descriptionStep.module.css';

export default function DescriptionStep ({ formData, setFormData }) {
  const navigate = useNavigate();

  const handleChange = (val, isValid) => {
    // Update form
    // Assume that one is selected
    // Destructure that object
    const selection = val.find(item => item.isChecked);
    setFormData((prevData) => ({
      ...prevData,
      descriptionStep: {
        value: selection?.value,
        description: val,
        isValid
      }
    }));

    // Update url params
    const searchParams = new URLSearchParams(window.location.search);
    if (isValid) {
      const newParam = val.find(
        item => item.isChecked
      ).value;
      searchParams.set('d', newParam);
    } else {
      searchParams.delete('d');
    }

    navigate(`?${searchParams.toString()}`, { replace: true });
  };

  return (
    <div className={styles.pageContainer}>
      <h2 className={styles.title}>
        Which of the following best describes you?
      </h2>
      <p className={styles.helpText}>
        This helps us match the requirements with the services you deliver or
        are interested in.
      </p>
      <p className={styles.selectText}>Select one option</p>
      <RadioButton
        className={styles.radioButtonContainer}
        options={formData.descriptionStep.description}
        handleChange={handleChange}
      />
    </div>
  );
}
